import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/core/service/environment.service';
import { Observable } from 'rxjs';

/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  serverUrl = '';

  constructor(environment: EnvironmentService) {
    this.serverUrl = environment.serverUrl;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isAbsolute = /^https?:\/\//i.test(request.url);

    request = request.clone({
      url: isAbsolute ? request.url : this.serverUrl + request.url,
      withCredentials: !isAbsolute
    });

    return next.handle(request);
  }
}

export const ApiPrefixInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ApiPrefixInterceptor,
  multi: true
};
